// extracted by mini-css-extract-plugin
export default {"jobMain":"PostJob_jobMain__MrMb3","jobForm":"PostJob_jobForm__enSSY","inputRow":"PostJob_inputRow__PapEd","reactQill":"PostJob_reactQill__JhfVS"};